import type { TerminalType } from './common'

export interface LiveItem {
  videoAddress: string
  userCount: number
  gameId: number
  gameType: number
  gameName: string
  platformCode: string
  gameCode: string
  aliasCode: string
  title?: string // 游戏标题，可选字段，用于兼容H5的LiveStream
}

// banner对象 首页，存款页等多出都有用
export interface BannerListDTO {
  /*创建时间: */
  createTime: Record<string, unknown>

  /*创建人: */
  creator: string

  /*最后修改时间: */
  updateTime: Record<string, unknown>

  /*最后修改人: */
  updater: string

  /*主键: */
  id: number

  /*图片类型  1首页banner 2 存款banner 3首页弹窗 */
  imgType: number

  /*开启状态 0关闭 1启用 */
  status: boolean

  /* */
  sort: number

  /*展示对象类型  1所有会员 2仅会员 3仅游客 4仅代理 */
  showMemberType: number

  /*展示时间类型  1长期有效 2 只设置开始时间 3自定义时间 */
  showTimeType: number

  /*开始时间 */
  startTime: Record<string, unknown>

  /*结束时间 */
  endTime: Record<string, unknown>

  /*图片h5 */
  imageH5: string

  /*图片PC */
  imagePc: string

  /*跳转类型 0无 1活动 2平台消息 3返水 4VIP 5分享赚钱 6外部链接 */
  jumpType: number

  /*跳转内容 */
  jumpContent: string

  /*备注 */
  remark: string

  /*1展示中，2未展示，3已过期，4已停用 */
  currentStatus: number

  /*终端类型 */
  terminalType: TerminalType[]
}

/**
 * 弹窗广告展示对象类型
 * 1所有会员 2仅会员 3仅游客 4仅代理
 */
export enum AdvertisePermission {
  ALL_USERS = 1,
  MEMBER_ONLY = 2,
  GUEST_ONLY = 3,
  AGENT_ONLY = 4
}

/** 首页公告弹窗数据 */
export interface HomeNoticeDto {
  /*标题 */
  title: string

  /*内容 */
  content: string

  /*消息id */
  id: number

  /*发送时间 */
  sendTime?: Record<string, unknown>
}

export interface HomeMarqueeNoticeDTO {
  /*内容 */ content: string

  // 多语言内容字段
  contentZh?: string
  contentEn?: string
  contentVi?: string
  contentHi?: string
  contentTa?: string
  contentMs?: string
  contentPt?: string

  /*备注 */
  remark?: string

  /*展示对象类型 0全部 1仅会员 2仅游客 */
  showMemberType: number
}

export interface SupportAreaConfigDTO {
  status: string
  title?: string
  titleZh?: string
  titleEn?: string
  titleVi?: string
  titleHi?: string
  titleTa?: string
  titleMs?: string
  titlePt?: string
  titleBn?: string
  titleKm?: string
  titleZhHant?: string
  titleEnSg?: string
  titleZhSg?: string
  content?: string
  contentZh?: string
  contentEn?: string
  contentVi?: string
  contentHi?: string
  contentTa?: string
  contentMs?: string
  contentPt?: string
  contentBn?: string
  contentKm?: string
  contentZhHant?: string
  contentEnSg?: string
  contentZhSg?: string
}

export interface SupportAreaReviewDTO {
  id: number
  avatarUrl?: string
  username: string
  rating: number
  sortValue: number
  content?: string
  contentZh?: string
  contentEn?: string
  contentVi?: string
  contentHi?: string
  contentTa?: string
  contentMs?: string
  contentPt?: string
  contentBn?: string
  contentKm?: string
  contentZhHant?: string
  contentEnSg?: string
  contentZhSg?: string
}

export const enum HoverType {
  USER = 'user',
  Wallet = 'wallet'
}
